import React from 'react';
import { Tooltip } from '@material-ui/core';
import { CloseIcon, StopHandIcon } from '../../Components/Icons';
import { white, white50 } from '../../Styles/Colours';
import { Button, ButtonMode } from '../../Components/Button';
import styles from './UrgentWarning.module.css';
export var UrgentWarning = function (props) { return (React.createElement("div", { className: styles.urgentWarningHeader },
    React.createElement(StopHandIcon, { size: '64', color: white, noPadding: true }),
    React.createElement("div", { className: styles.close },
        React.createElement(Tooltip, { title: 'Close' },
            React.createElement("span", null,
                React.createElement(Button, { iconOnly: true, onClick: props.onCancel, mode: ButtonMode.text, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'close-urgent-warning' },
                    React.createElement(CloseIcon, { size: '20', color: white50, noPadding: true }))))))); };
